<div *ngIf="!isBannerClosed" class="sticky-promo-banner success">
    <div class="content">
      <strong *ngIf="header">{{header}}&nbsp;&nbsp;</strong>
      <span *ngIf="body">{{body}}&nbsp;&nbsp;</span>
      <span class="btn-wrapper">
        <button class="mr-4"
          *ngIf="primaryBtnText"
          phx-button
          [phxButtonRole]="'primary'"
          [phxButtonType]="'default'"
          [phxBackground]="'bold'"
          [phxSize]="'small'"
          (phxOnClick)="handleCTAClick($event)"
        >
          {{primaryBtnText}}
        </button>
        <button
          *ngIf="secondaryBtnText"
          phx-button
          [phxButtonRole]="'secondary'"
          [phxButtonType]="'default'"
          [phxBackground]="'bold'"
          [phxSize]="'small'"
          (phxOnClick)="handleCTAClick($event)"
        >
          {{secondaryBtnText}}
        </button>
      </span>
    </div>
    <div class="close" (click)="closeBanner()"></div>
</div>